var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCommunityOrchestration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15 -421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1508 429.056C25.1778 429.059 24.2442 428.672 23.5582 427.982L21.3491 425.773 22.6455 424.477 24.8542 426.686C25.5701 427.402 26.7308 427.402 27.4467 426.686L29.6559 424.477 30.9523 425.773 28.7431 427.982C28.057 428.672 27.1236 429.059 26.1508 429.056Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6564 439.523 27.4472 437.314C26.7312 436.598 25.5706 436.598 24.8546 437.314L22.6455 439.523 21.3491 438.227 23.5582 436.018C24.9901 434.586 27.3117 434.586 28.7436 436.018L30.9528 438.226Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2281 436.802 30.0189 434.593C28.5894 433.16 28.5894 430.84 30.0189 429.407L32.2281 427.198 33.5247 428.494 31.3153 430.703C30.6005 431.419 30.6005 432.579 31.3153 433.296L33.5247 435.505Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7747 436.802 18.4781 435.506 20.6872 433.297C21.4022 432.581 21.4022 431.421 20.6872 430.704L18.4781 428.495 19.7747 427.199 21.9839 429.408C23.4132 430.841 23.4132 433.16 21.9839 434.593Z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCommunityOrchestration);
export default __webpack_public_path__ + "static/media/icon-community-orchestration.e56bb2e594567a49cf1319aa765662ec.svg";
export { ForwardRef as ReactComponent };